"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainClassSecond = exports.TrainClassFirst = exports.DirectionTrainRoundTrip = exports.DirectionTrainReturning = exports.DirectionTrainOutgoing = void 0;
exports.DirectionTrainOutgoing = 'O';
exports.DirectionTrainReturning = 'R';
exports.DirectionTrainRoundTrip = 'RT';
exports.TrainClassFirst = '1';
exports.TrainClassSecond = '2';
//# sourceMappingURL=book_request.js.map